<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" router>
            <el-menu-item index="/home/patient/dashboard">Dashboard</el-menu-item>
            <el-menu-item index="/home/patient/patientlist">病人库</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
         activeIndex: this.$route.path,
        handleSelect(key, keyPath) {
        }
      }
    },
    mounted:function () {
      console.log(window.location.href);                         //完整url可以用
      console.log(this.$route.path) ;                          //路由路径可以用
      console.log(this.$route.params)                              //路由路径参数
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// patientmenu.vue?e80c4624